<template>
    <v-btn
        class="white--text ma-4"
        color="light-blue darken-4"
        href="https://stackoverflow.com/users/3586038/keith-dawson"
    >
        <v-icon class="blue--text text--lighten-3">{{ icons.stackOverflow }}</v-icon>
        <span class="ml-2">View Profile</span>
    </v-btn>
</template>

<script>
import { mdiStackOverflow } from '@mdi/js'

export default {
    name: 'StackoverflowProfileButton',
    data() {
        return {
            icons: {
                stackOverflow: mdiStackOverflow,
            },
        }
    },
}
</script>

<style scoped>

</style>